(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-bloques"] && !Shopify.designMode) return;
  try {
    
/* Swiper JS inicialización */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.swiper').forEach(function(swiperEl) {
    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 12,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: swiperEl.querySelector('.swiper-button-next'),
        prevEl: swiperEl.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
